import { Component } from 'preact'
import InputGroup from '../../ui-components/InputGroup'
import getWithInMemoryCache from '../../../utils/getWithInMemoryCache'
import QuickLink from '../../quick-links/QuickLink'
import EditKnowledgeBase from './EditKnowledgeBase'
import Hover from '../../hover/Hover'

export default class KnowledgeBaseHomepageManager extends Component {
  constructor (props) {
    super(props)

    this.state = {
      title: props.knowledge_base_homepage_title,
      parentCategories: []
    }
  }

  componentDidMount () {
    getWithInMemoryCache('/site/knowledgeBase', {})
      .then(data => this.setState({
        parentCategories: data.categoryGroups
      }))
  }

  componentDidUpdate () {
    this.props.onChange({ knowledge_base_homepage_title: this.state.title })
  }

  render (props, state) {
    return (
      <div>
        <InputGroup
          title='Title'
          type='text'
          onChange={(e) => { this.setState({ title: e.target.value }) }}
          value={state.title} />
        {
          state.parentCategories.length ? (
            <ul className='quicklink__container--knowledgeBase'>
              {
                state.parentCategories.map((item, idx) => (
                  <Hover hoverComponent={<EditKnowledgeBase link={`/platform/knowledge-base/edit?id=${item.id}`} />}>
                    <QuickLink {...props} item={item} idx={idx} />
                  </Hover>
                ))
              }
            </ul>
          ) : <p>There is no knowledge base category available yet. Start by <a href='/platform/knowledge-base'>adding knowledge base category</a>.</p>
        }
      </div>
    )
  }
}
